import * as PIXI from 'pixi.js-legacy';

function getVertices(vertices, face = 'front') {
  switch (face) {
    case 'front':
      return [vertices[0], vertices[1], vertices[2], vertices[3]];
    case 'back':
      return [vertices[5], vertices[6], vertices[7], vertices[4]];
    case 'top':
      return [vertices[3], vertices[2], vertices[6], vertices[7]];
    case 'bottom':
      return [vertices[0], vertices[1], vertices[5], vertices[4]];
    case 'left':
      return [vertices[0], vertices[4], vertices[7], vertices[3]];
    case 'right':
      return [vertices[1], vertices[2], vertices[6], vertices[5]];
    default:
      throw new Error('Unknown face');
  }
}

export default {
  outline: {
    polygon(vertices, color = 0x33dd33, width = 2) {
      const graphic = new PIXI.Graphics();

      graphic.lineStyle(width, color, 1);

      graphic.moveTo(...vertices[0]);

      for (let i = 1; i < vertices.length; i++) {
        graphic.lineTo(...vertices[i]);
      }

      graphic.lineTo(...vertices[0]);

      return graphic;
    },

    face(vertices, face = 'front', color, width) {
      return this.polygon(getVertices(vertices, face), color, width);
    },
  },

  fill: {
    polygon(vertices, color = 0x33dd33) {
      const graphic = new PIXI.Graphics();

      graphic.beginFill(color);
      graphic.drawPolygon([].concat(...vertices));
      graphic.endFill();

      return graphic;
    },

    face(vertices, face = 'front', color) {
      return this.polygon(getVertices(vertices, face), color);
    },
  },
};
